import React from 'react';
import BlueTopPage from '@/components/templates/BlueTopPage';
import onboardingMessages from '@/messages/onboarding';
import { useUserOnboardingStore } from '@/store/useUserOnboardingStore';
import DemographicsForm from '@/components/organisms/DemographicsForm';
import useUpdateDemographics from '@/hooks/user/useUpdateDemographics';
import { TUser, TUserDemographicsInfo } from '@/types/User.types';
import { CENTERED_FORM_WIDTH } from '@/constants/dimensions';
import { Button, Text } from '@chakra-ui/react';

type Props = {
  onSubmitSuccess?: (user: TUser) => void;
  onSkip: () => void;
  isSkipping: boolean;
  isMember: boolean;
};

const DemographicsSetup = ({ onSubmitSuccess = () => {}, onSkip, isSkipping, isMember }: Props) => {
  const { demographics: currentUserInfo, setDemographics } = useUserOnboardingStore();

  const { mutate, isPending } = useUpdateDemographics((user) => {
    onSubmitSuccess(user);
  }, isMember);

  const onFormSubmit = (submittedDemographics: TUserDemographicsInfo) => {
    mutate(submittedDemographics);
    setDemographics(submittedDemographics);
  };

  return (
    <BlueTopPage
      description={onboardingMessages.yourStoryMattersDescription}
      headerAction={
        isMember && (
          <Text textAlign="center" color="text.veryLightBlue" lineHeight={'20px'} fontWeight={'600'} paddingTop="16px">
            <Text as="span" lineHeight={'20px'} fontWeight={'600'} opacity={0.7}>
              If you wish you can{' '}
            </Text>
            <Button variant="link" color="white" onClick={() => onSkip()} isDisabled={isPending || isSkipping}>
              skip demographics →
            </Button>
          </Text>
        )
      }
      title={onboardingMessages.yourStoryMatters}
      contentMaxWidth={CENTERED_FORM_WIDTH}
      hasOrangeGradient
      hasStickyHeader
    >
      <DemographicsForm
        onboarding={isMember}
        onSkip={isMember ? () => onSkip() : undefined}
        defaultFormValues={currentUserInfo}
        onSubmit={(data) => {
          onFormSubmit(data);
        }}
        isLoading={isPending || isSkipping}
      />
    </BlueTopPage>
  );
};

export default DemographicsSetup;
